import { render, staticRenderFns } from "./profile-view-changes-history.vue?vue&type=template&id=79a43494"
import script from "./profile-view-changes-history.vue?vue&type=script&lang=js"
export * from "./profile-view-changes-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports